import PropTypes from 'prop-types';
import React from 'react';
import { designSystem } from '@yola/ws-ui';

const { IconButton } = designSystem;

const Menu = ({ glyph = 'floating-menu', ...props }) => (
  <div className="ws-my-navbar__menu">
    <IconButton {...props} glyph={glyph} />
  </div>
);

Menu.propTypes = {
  glyph: PropTypes.string,
};

export default Menu;
